import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { Drawer } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import ComFunction from "../components/ComFunction";
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Divider from '@material-ui/core/Divider';
import RadioGroup from '@material-ui/core/RadioGroup';
import Radio from '@material-ui/core/Radio';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import Collapse from '@material-ui/core/Collapse';
import Icon from '@material-ui/core/Icon';
import IconButton from '@material-ui/core/IconButton';
import { makeStyles } from '@material-ui/core/styles';
import { isEmpty } from '../modules/appLibrary';
import {  setentrystartup } from '../modules/toolpanelstore';
import { entrysettingopen, opentheme} from '../modules/formstore';

const useStyles = makeStyles({
    list: {
        width: 250
    },
    fullList: {
        width: "auto"
    },
    paper: {
        background: "#F5F7F7"
    }
});

//---------------------------------------------------------------------
//  EntryForm レイアウト設定
//---------------------------------------------------------------------
export default function EntrySetting(props) {
    const fnc = useRef();
    const ComFunc = React.forwardRef(ComFunction);
    const mainlayout = useSelector(state => state.toolpnl.layouts_et);
    const mainprelayout = useSelector(state => state.toolpnl.prelayout_et);
    const maininitlayout = useSelector(state => state.toolpnl.initlayout_et);
    const mainfitColumn = useSelector(state => state.toolpnl.fitColumn_et);
    const settingopen = useSelector(state => state.form.entrysettingopen);

    const [show, setshow] = useState(false)
    const [initlayout, setinitlayout] = useState(' ');
    const [prelayout, setprelayout] = useState("0");
    const [fitColumn, setfitColumn] = useState(false);
    const [layouts, setlayouts] = useState([{ value: ' ', label: '既定レイアウト' }]);
    const [expandsave, setexpandsave] = useState(false);
    const layoutnameRef = useRef();

    const classes = useStyles();
    const dispatch = useDispatch();

    useEffect(() => {
        setshow(settingopen);
        if (settingopen) {
            setlayouts(mainlayout);
            setprelayout(mainprelayout ? "0" : "1");
            setinitlayout(maininitlayout);
            setfitColumn(mainfitColumn);
        }
    }, [settingopen])

    useEffect(() => {
        if (settingopen) {
            setlayouts(mainlayout);
        }
    }, [mainlayout])

    function onHandleClose() {
        dispatch(entrysettingopen(false));
    };

    function settingexec() {
        fnc.current.confmsg("起動時設定を登録します。よろしいですか？", () => SavePropaty());
    }
    function SavePropaty() {
        fnc.current.postaxios('common/SaveStartupPropaty',
            {
                "controller": props.controller, "subkey": props.subkey, "type": "100",
                "prelayout": prelayout === "0" ? true : false,
                "initlayout": initlayout,
                "fitColumn": isEmpty(fitColumn) ? false : fitColumn,
                "showlimit": "0"
            },
            {
                onSuccess: function (data) {
                    dispatch(setentrystartup({
                        prelayout: prelayout === "0",
                        initlayout: initlayout,
                        fitColumn: fitColumn
                    }));
                    fnc.current.success();
                    fnc.current.wait(false);
                },
            }
        )
    }
    function savemenuexec() {
        if (isEmpty(layoutnameRef.current.value)) {
            fnc.current.warnmsg("メニュタイトルを入力してください");
            return;
        }
        fnc.current.confmsg(["現在のレイアウトをメニュに登録します。よろしいですか？", "メニュはマイアプリケーションリストに登録されます"], () => props.savelayout(1, layoutnameRef.current.value));
    }
    function callexec(layout) {
        fnc.current.confmsg("レイアウトを「" + layout + "」に変更します。よろしいですか？", () => props.calllayout(layout));
    }
    function clearlayout() {
        fnc.current.confmsg("既定レイアウトに変更します。よろしいですか？", () => props.calllayout(' '));
    }
    function saveexec() {
        if (isEmpty(layoutnameRef.current.value)) {
            fnc.current.warnmsg("レイアウト名を入力してください");
            return;
        }
        fnc.current.confmsg("現在のレイアウトを登録します。よろしいですか？", () => props.savelayout(layoutnameRef.current.value));
    }
    function deletelayout(layoutid) {
        fnc.current.confmsg("レイアウト'" + layoutid + "'を削除します。よろしいですか？", () => props.deletelayout(layoutid));
    }
    function OpenTheme() {
        onHandleClose();
        dispatch(opentheme(true));
    }
    function SaveLayout() {
        return <React.Fragment>
            <Divider />
            <ListItem>
                <ListItemText primary="登録レイアウト" />
            </ListItem>
            {layouts.filter(e => e.value !== " ").map((option) => (
                <ListItem style={{ paddingTop: 0, paddingBottom: 0, margin: 0 }}>
                    <Button style={{ justifyContent: "flex-start" }} fullWidth={true} size="small" onClick={() => callexec(option.value)}>{option.value}</Button >
                    <IconButton edge="end" size="small" title="削除" onClick={() => deletelayout(option.value)} style={{ marginLeft: 5 }}>
                        <Icon>delete</Icon>
                    </IconButton>
                </ListItem>
            ))}
        </React.Fragment>
    }
    function HidePanel() {
        return <React.Fragment>
            <Divider />
            <ListItem>
                <ListItemText primary="非表示パネル ※クリックで表示" />
            </ListItem>
            {props.panels.filter(e => e.hide).map((option) => (
                <ListItem style={{ paddingTop: 0, paddingBottom: 0, margin: 0 }}>
                    <Button style={{ justifyContent: "flex-start" }} fullWidth={true} size="small" onClick={() => props.showpanel(option.id, option.type, true)}>{option.name}</Button >
                </ListItem>
            ))
            }
        </React.Fragment>
    }
    function EntryLayout() {
        var panels = [];
        if (!isEmpty(props.panels)) panels = props.panels;
        return <React.Fragment>
            <div style={{ marginRight: 10 }}>
                <div style={{ textAlign: 'left', float: 'left', marginTop: 10, marginLeft: 10, marginBottom:10 }}>
                    <span >レイアウト管理</span>
                </div>
                <List
                    sx={{ width: '100%', bgcolor: 'background.paper' }}
                    component="nav"
                    aria-labelledby="nested-list-subheader"
                >
                    <ListItem button onClick={OpenTheme}>
                        <ListItemText primary="テーマ設定" />
                    </ListItem>
                    <Divider />
                    <ListItem>
                        <ListItemText primary="起動時設定" />
                        <Button variant="outlined" size="small" onClick={settingexec}>設定</Button>
                    </ListItem>
                    <ListItem>
                        <RadioGroup
                            name="initlayout"
                            value={prelayout}
                            onChange={(e) => setprelayout(e.target.value)}
                        >
                            <FormControlLabel value="0"
                                control={<Radio size="small" />}
                                label={<span style={{ fontSize: 12 }}>前回レイアウトを表示</span>}
                            />
                            <FormControlLabel value="1"
                                control={<Radio size="small" />}
                                label={<span style={{ fontSize: 12 }}>レイアウト指定</span>}
                            />
                        </RadioGroup>
                    </ListItem>
                    <ListItem style={{ marginBottom: 10 }}>
                        <TextField
                            select
                            label=""
                            value={initlayout}
                            fullWidth
                            onChange={(e) => setinitlayout(e.target.value)}
                        >
                            {layouts.map((option) => (
                                <MenuItem key={option.value} value={option.value} style={{ fontSize: 10 }}>
                                    {option.label}
                                </MenuItem>
                            ))}
                        </TextField>
                    </ListItem>
                    {/*<ListItem>*/}
                    {/*    <FormControlLabel*/}
                    {/*        control={<Checkbox size="small" checked={fitColumn} onChange={(e) => setfitColumn(e.target.checked)} />}*/}
                    {/*        label={<span style={{ fontSize: 12 }}>列幅を最適化する</span>}*/}
                    {/*    />*/}
                    {/*</ListItem>*/}
                     <Divider />
                    <ListItem button onClick={() => setexpandsave(!expandsave)}>
                        <ListItemText primary="現在のレイアウトを登録" />
                    </ListItem>
                    <Collapse in={expandsave} timeout="auto" unmountOnExit>
                        <List component="div" disablePadding>
                            <ListItem>
                                <Button variant="outlined" size="small" onClick={saveexec}>ﾚｲｱｳﾄ登録</Button>
                            {/*    <Button variant="outlined" size="small" onClick={savemenuexec}>ﾒﾆｭ登録</Button>*/}
                            </ListItem>
                            <ListItem>
                                <TextField
                                    inputRef={layoutnameRef}
                                    label="レイアウト名" size="small" inputProps={{ maxLength: 30 }} fullWidth />
                            </ListItem>
                        </List>
                    </Collapse>
                    <Divider />
                    <ListItem button onClick={clearlayout}>
                        <ListItemText primary="既定レイアウトに戻す" />
                    </ListItem>
                    {layouts.filter(e => e.value !== " ").length === 0 ? null : <SaveLayout />}
                    {panels.filter(e => e.hide).length === 0 ? null :<HidePanel/>}
                </List>

            </div>
        </React.Fragment>
    }
    return (
        <div>
            <Drawer
                classes={{ paper: classes.paper }}
                anchor={"right"}
                open={show}
                onClose={onHandleClose}
                BackdropProps={{ invisible: true }}
            >
                <EntryLayout />
            </Drawer>
            <ComFunc ref={fnc} />
        </div>
    );
};
